
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component
export default class DatePicker extends Vue {
	@Prop()
	private selectedDate!: string;
	@Prop()
	private label!: string;
	@Prop()
	private hint!: string;
	/** Renders the activator field in Vuetify's compact height. */
	@Prop({ default: false })
	private dense!: boolean;
	/** Earliest selectable day. Defaults to the usual production lead time of 21 days. */
	@Prop({ default: () => moment().add(21, "day").format("YYYY-MM-DD") })
	private minDate!: string;
	/** Latest selectable day. An empty value means there is no upper limit. */
	@Prop({ default: "" })
	private maxDate!: string;
	/** Shows the date as it is, without opening the calendar. */
	@Prop({ default: false })
	private isReadonly!: boolean;

	private datePickerOpen: boolean = false;
	private internalDate: string = "";
	/** Month the calendar shows, as YYYY-MM. Kept in sync so the user can still browse. */
	private pickerDate: string = "";

	private mounted() {
		this.setDate();
	}
	@Watch("selectedDate")
	private update() {
		this.setDate();
	}

	/**
	 * Opens the calendar on a useful month. Without this it would always start on the
	 * current month, which is pointless when the earliest selectable day is later.
	 */
	@Watch("datePickerOpen")
	private onPickerOpened(isOpen: boolean) {
		if (!isOpen) {
			return;
		}
		const month = this.internalDate || this.minDate || "";
		this.pickerDate = month.substring(0, 7);
	}

	// An empty value stays empty. Formatting it would turn it into today's date and
	// silently prefill a field the user has not answered yet.
	private setDate() {
		this.internalDate = this.selectedDate ? moment(this.selectedDate).format("YYYY-MM-DD") : "";
	}

	private get locale() {
		return this.$i18n.locale.toLowerCase();
	}

	private get selectedDateFormated() {
		return this.internalDate ? moment(this.internalDate).format("DD.MM.YYYY") : "";
	}

	private dateChanged() {
		this.$emit("update:selectedDate", this.internalDate);
		this.datePickerOpen = false;
	}
}
